import { useEffect } from "react";
import { api } from "@/lib/api";

const TAB = Math.random().toString(36).slice(2, 12);

// Heartbeat de presença do painel: só aba visível conta; ao fechar, avisa a saída
export const usePresenca = (ativo) => {
  useEffect(() => {
    if (!ativo) return undefined;
    const ping = () => { if (!document.hidden) api.post("/presenca/ping", { tab: TAB }).catch(() => {}); };
    const sair = () => {
      const base = process.env.REACT_APP_BACKEND_URL;
      const tok = localStorage.getItem("cp_token");
      try {
        fetch(`${base}/api/presenca/sair`, { method: "POST", keepalive: true,
          headers: { "Content-Type": "application/json", ...(tok ? { Authorization: `Bearer ${tok}` } : {}) },
          body: JSON.stringify({ tab: TAB }) });
      } catch (_) { /* expira sozinho em 75s */ }
    };
    const onVis = () => { if (document.hidden) sair(); else ping(); };
    ping();
    const t = setInterval(ping, 30000);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", sair);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("pagehide", sair);
    };
  }, [ativo]);
};
